import { BasicCustomCursor } from "@goodgamestudios/core";
import { ColorMatrix } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

/**
 * Behaves most like the BasicButton, but decorates a given movieclip, instead of extending movieclip.
 * Don't auto-adjust width (needed especially for the login button within the login panel for the language switch)
 * @author Patrick
 */
export class RabbitCamButton {
    private _view: MovieClip;
    private _isSelected: boolean = false;
    private _enabled: boolean = false;
    private _colorMatrix: ColorMatrix;
    private _background: MovieClip;
    private _tf_label: TextField;
    private _tf_labelGold: TextField;
    private _filters: any;

    constructor(view: MovieClip) {
        this._view = view;

        this.init();
    }

    private init(): void {
        this._background = this._view.mc_background;
        this._tf_label = this._view.txt_label;
        this._tf_labelGold = this._view.txt_label2;

        this._view.useHandCursor = true;
        this._view.buttonMode = true;
        this._view.mouseChildren = false;
        this._view.tabEnabled = false;
        this.enableButton = true;

        if (this._view.totalFrames > 1)
            this._view.gotoAndStop(1);
        if (this._background && this._background.totalFrames > 1)
            this._background.gotoAndStop(1);

        this._view.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOver));
        this._view.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOut));
    }

    public set label(textStr: string) {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this._tf_label, textStr);
    }

    public set gold(textStr: string) {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this._tf_labelGold, textStr);
    }

    public set enableButton(value: boolean) {
        this._enabled = value;
        if (this._colorMatrix == null) {
            this._colorMatrix = new ColorMatrix();
            this._colorMatrix.desaturate();
        }
        this._filters = (value) ? null : [this._colorMatrix.filter];
        this.onRollOut(null);
    }

    public get isSelected(): boolean {
        return this._isSelected;
    }

    public selected(): void {
        this._isSelected = true;
        if (this._enabled && this._background && this._background.totalFrames > 1)
            this._background.gotoAndStop(3);
        else
            if (this._enabled && this._background.totalFrames > 1)
                this._background.gotoAndStop(3);
    }

    public deselected(): void {
        this._isSelected = false;
        if (this._enabled && this._background)
            this._background.gotoAndStop(1);
        else
            if (this._enabled)
                this._background.gotoAndStop(1);
    }

    public onRollOut(event: MouseEvent): void {
        if (this._isSelected) {
            return;
        }

        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);

        if (this._enabled && this._background && this._background.totalFrames > 1) {
            this._background.gotoAndStop(1);
        }
        else {
            if (this._enabled && this._background.totalFrames > 1) {
                this._background.gotoAndStop(1);
            }
        }
    }

    public onRollOver(event: MouseEvent): void {
        if (this._isSelected) {
            return;
        }

        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);

        if (this._enabled && this._background && this._background.totalFrames > 1) {
            this._background.gotoAndStop(2);
        }
        else {
            if (this._enabled && this._background.totalFrames > 1) {
                this._background.gotoAndStop(2);
            }
        }
    }
}
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
